/**
 * @generated SignedSource<<0c6d8d050d12478d4b25c94a2ea6d45f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItems_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItems_seller" | "NavItem_seller">;
  readonly " $fragmentType": "NavItems_seller";
};
export type NavItems_seller$key = {
  readonly " $data"?: NavItems_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItems_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItems_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavExpandingAreaItems_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "3cfc458d220d0605a69518a8e6e1ed1c";

export default node;
